export default {
    // Chess Tactics
    "frame": {
        "width": 16,
        "height": 9,
    },
    "grid": {
        "width": 1,
        "height": 1,
    },
    "camera": {
        "type": "top-down",
        "position": {
            "x": 0,
            "y": 0,
        }
    },
    "defaultAnchor": {
        "x": 0.5,
        "y": 1,
    },
}
